import { format, differenceInMilliseconds } from 'date-fns';

export default {
  methods: {
    transformDateToDisplay(date) {
      return format(new Date(date), 'dd/MM/yyyy');
    },
    transformDateToDisplayTime(date) {
      return format(new Date(date), 'HH:mm');
    },
    formatDate(date) {
      return format(new Date(date), 'yyyy-MM-dd');
    },
    formatDateTime(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss');
    },
    formatTimeDate(date) {
      return format(new Date(date), 'HH:mm:ss dd/MM/yyyy ');
    },
    formatLongDate(date) {
      return format(new Date(date), 'HH:mm:ss @ MMM d, yyyy');
    },
    formatLongDateTime(date) {
      return format(new Date(date), 'HH:mm:ss @ MMM d, yyyy');
    },
    formatLongDateTimeWithMs(date) {
      return format(new Date(date), 'HH:mm:ss.SSS @ MMM d');
    },
    formatLongDateOnly(date) {
      return format(new Date(date), 'MMM d, yyyy');
    },
    formatLongTime(date) {
      return format(new Date(date), 'HH:mm:ss');
    },
    formatLongTimeWithMs(date) {
      return format(new Date(date), 'HH:mm:ss.SSS');
    },
    formatShortDate(date) {
      return format(new Date(date), 'd MMM');
    },
    formatTime(date) {
      return format(new Date(date), 'HH:mm');
    },
    differenceInMilliseconds(dateLeft, dateRight) {
      return differenceInMilliseconds(dateLeft, dateRight);
    },
    transformTime(seconds) {
      let formattedSecond = '';
      // return seconds;
      switch (true) {
        case seconds < 60:
          formattedSecond = seconds;
          break;
        case seconds > 60 && seconds < 3600:
          formattedSecond = `${Math.floor(seconds / 60)} M.`;
          break;
        default:
          formattedSecond = '0 Second';
          break;
      }
      return formattedSecond;
    },
    transformTimeCode(rawSeconds) {
      const hours = Math.floor(rawSeconds / 3600);
      const minutes = Math.floor((rawSeconds / 60) % 60);
      const seconds = Math.floor(rawSeconds % 60);
      const milliSeconds = Math.floor((rawSeconds * 1000) % 1000);

      let hoursString = '0';
      if (hours > 0) {
        hoursString = `${hours}`;
      }

      let minutesString = '00';
      if (minutes >= 10) {
        minutesString = `${minutes}`;
      } else if (minutes > 0) {
        minutesString = `0${minutes}`;
      }

      let secondsString = '00';
      if (seconds >= 10) {
        secondsString = `${seconds}`;
      } else if (minutes > 0) {
        secondsString = `0${seconds}`;
      }

      let milliSecondsString = '000';
      if (milliSeconds >= 100) {
        milliSecondsString = `${milliSeconds}`;
      } else if (milliSeconds >= 10) {
        milliSecondsString = `0${milliSeconds}`;
      } else if (milliSeconds > 0) {
        milliSecondsString = `00${milliSeconds}`;
      }

      return `${hoursString}:${minutesString}:${secondsString}.${milliSecondsString}`;
    },
  },
};
